"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/es.number.constructor.js");

require("core-js/modules/web.timers.js");

var _vuePopper = _interopRequireDefault(require("element-ui/lib/utils/vue-popper"));

var _dom = require("element-ui/lib/utils/dom");

var _util = require("element-ui/lib/utils/util");

var _button = _interopRequireDefault(require("element-ui/lib/button"));

var _locale = _interopRequireDefault(require("element-ui/lib/mixins/locale"));

var __vue_render__ = function __vue_render__(h) {
  var _vm = this;

  var _h = _vm.$createElement;
  var _c = h;
  return _c('span', [_c('transition', {
    attrs: {
      "name": _vm.transition
    },
    on: {
      "after-enter": _vm.handleAfterEnter,
      "after-leave": _vm.handleAfterLeave
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.disabled && _vm.showPopper,
      expression: "!disabled && showPopper"
    }],
    ref: "popper",
    staticClass: "el-popover el-popper",
    "class": [_vm.popperClass, _vm.content && 'el-popover--plain'],
    style: {
      width: _vm._px2rem(_vm.width + 'px', 24, []),
      'min-height': _vm.minHeight || '0' + 'px'
    },
    attrs: {
      "role": "tooltip",
      "id": _vm.tooltipId,
      "aria-hidden": _vm.disabled || !_vm.showPopper ? 'true' : 'false'
    }
  }, [_vm.title ? _c('div', {
    staticClass: "el-popover__title",
    attrs: {},
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("default", [_vm._v(_vm._s(_vm.content))], {}), _vm._v(" "), _vm.hasFooter ? _c('div', {
    staticClass: "el-popover__footer",
    attrs: {}
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleOk
    }
  }, [_vm._v(_vm._s(_vm.t('el.popover.confirm')) + " ")]), _vm._v(" "), _c('el-button', {
    attrs: {},
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v(_vm._s(_vm.t('el.popover.cancel')))])], 1) : _vm._e()], 2)]), _vm._v(" "), _vm._t("reference", null, {})], 2);
};

var __vue_staticRenderFns__ = [];
var _default = {
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__,
  name: 'ElPopover',
  mixins: [_vuePopper["default"], _locale["default"]],
  props: {
    trigger: {
      type: String,
      "default": 'click',
      validator: function validator(value) {
        return ['click', 'focus', 'hover', 'manual'].indexOf(value) > -1;
      }
    },
    openDelay: {
      type: Number,
      "default": 0
    },
    title: String,
    disabled: Boolean,
    showFooter: Boolean,
    content: String,
    reference: {},
    popperClass: String,
    width: {},
    minHeight: [String],
    visibleArrow: {
      "default": true
    },
    arrowOffset: {
      type: Number,
      "default": 0
    },
    transition: {
      type: String,
      "default": 'fade-in-linear'
    },
    hasFooter: {
      type: Boolean,
      "default": false
    }
  },
  components: {
    ElButton: _button["default"]
  },
  computed: {
    tooltipId: function tooltipId() {
      return "el-popover-".concat((0, _util.generateId)());
    }
  },
  watch: {
    showPopper: function showPopper(val) {
      if (this.disabled) {
        return;
      }

      val ? this.$emit('show') : this.$emit('hide');
    }
  },
  mounted: function mounted() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;

      var reference = this.referenceElm = this.reference || this.$refs.reference;
      var popper = this.popper || this.$refs.popper;

      if (!reference && this.$slots.reference && this.$slots.reference[0]) {
        reference = this.referenceElm = this.$slots.reference[0].elm;
      }

      if (!reference) {
        return;
      } // 可访问性


      (0, _dom.addClass)(reference, 'el-popover__reference');
      reference.setAttribute('aria-describedby', this.tooltipId);

      if (!reference.getAttribute('tabindex')) {
        reference.setAttribute('tabindex', 0); // tab序列
      }

      popper.setAttribute('tabindex', 0);

      if (this.trigger !== 'click') {
        (0, _dom.on)(reference, 'focusin', function () {
          _this.handleFocus();

          var instance = reference.__vue__;

          if (instance && typeof instance.focus === 'function') {
            instance.focus();
          }
        });
        (0, _dom.on)(popper, 'focusin', this.handleFocus);
        (0, _dom.on)(reference, 'focusout', this.handleBlur);
        (0, _dom.on)(popper, 'focusout', this.handleBlur);
      }

      (0, _dom.on)(reference, 'keydown', this.handleKeydown);
      (0, _dom.on)(reference, 'click', this.handleClick);

      if (this.trigger === 'click') {
        (0, _dom.on)(reference, 'click', this.doToggle);
        (0, _dom.on)(document, 'click', this.handleDocumentClick);
      } else if (this.trigger === 'hover') {
        (0, _dom.on)(reference, 'mouseenter', this.handleMouseEnter);
        (0, _dom.on)(popper, 'mouseenter', this.handleMouseEnter);
        (0, _dom.on)(reference, 'mouseleave', this.handleMouseLeave);
        (0, _dom.on)(popper, 'mouseleave', this.handleMouseLeave);
      } else if (this.trigger === 'focus') {
        if (reference.querySelector('input, textarea')) {
          (0, _dom.on)(reference, 'focusin', this.doShow);
          (0, _dom.on)(reference, 'focusout', this.doClose);
        } else {
          (0, _dom.on)(reference, 'mousedown', this.doShow);
          (0, _dom.on)(reference, 'mouseup', this.doClose);
        }
      }
    },
    doToggle: function doToggle() {
      if (this.$root && this.$root.popover) {
        this.showPopper = true;
        this.updatePopper(this.referenceElm);
      } else {
        this.showPopper = !this.showPopper;
      }
    },
    doShow: function doShow() {
      this.showPopper = true;
    },
    doClose: function doClose() {
      this.showPopper = false;
    },
    handleFocus: function handleFocus() {
      (0, _dom.addClass)(this.referenceElm, 'focusing');
      if (this.trigger !== 'manual') this.showPopper = true;
    },
    handleClick: function handleClick() {
      (0, _dom.removeClass)(this.referenceElm, 'focusing');
    },
    handleBlur: function handleBlur() {
      (0, _dom.removeClass)(this.referenceElm, 'focusing');
      if (this.trigger !== 'manual') this.showPopper = false;
    },
    handleMouseEnter: function handleMouseEnter() {
      var _this2 = this;

      clearTimeout(this._timer);

      if (this.openDelay) {
        this._timer = setTimeout(function () {
          _this2.showPopper = true;
        }, this.openDelay);
      } else {
        this.showPopper = true;
      }
    },
    handleKeydown: function handleKeydown(ev) {
      if (ev.keyCode === 27 && this.trigger !== 'manual') {
        // esc
        this.doClose();
      }
    },
    handleMouseLeave: function handleMouseLeave() {
      var _this3 = this;

      clearTimeout(this._timer);
      this._timer = setTimeout(function () {
        _this3.showPopper = false;
      }, 200);
    },
    handleDocumentClick: function handleDocumentClick(e) {
      var reference = this.reference || this.$refs.reference;
      var popper = this.popper || this.$refs.popper;

      if (!reference && this.$slots.reference && this.$slots.reference[0]) {
        reference = this.referenceElm = this.$slots.reference[0].elm;
      }

      if (!this.$el || !reference || this.$el.contains(e.target) || reference.contains(e.target) || !popper || popper.contains(e.target)) return;
      this.showPopper = false;
    },
    handleAfterEnter: function handleAfterEnter() {
      this.$emit('after-enter');
    },
    handleAfterLeave: function handleAfterLeave() {
      this.$emit('after-leave');
      this.doDestroy();
    },
    destroyEvent: function destroyEvent() {
      var reference = this.reference;
      (0, _dom.off)(reference, 'click', this.doToggle);
      (0, _dom.off)(reference, 'mouseup', this.doClose);
      (0, _dom.off)(reference, 'mousedown', this.doShow);
      (0, _dom.off)(reference, 'focusin', this.doShow);
      (0, _dom.off)(reference, 'focusout', this.doClose);
      (0, _dom.off)(reference, 'mousedown', this.doShow);
      (0, _dom.off)(reference, 'mouseup', this.doClose);
      (0, _dom.off)(reference, 'mouseleave', this.handleMouseLeave);
      (0, _dom.off)(reference, 'mouseenter', this.handleMouseEnter);
    },
    handleOk: function handleOk() {
      this.$emit('ok');
    },
    handleCancel: function handleCancel() {
      this.showPopper = false;
    }
  },
  destroyed: function destroyed() {
    this.destroyEvent();
    (0, _dom.off)(document, 'click', this.handleDocumentClick);
  }
};
exports["default"] = _default;